"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

require("./BB8MainPage.scss");

require("./BB8Shared.scss");

var BB8MainPage =
/** @class */
function (_super) {
  __extends(BB8MainPage, _super);

  function BB8MainPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  BB8MainPage.prototype.render = function () {
    var children = this.props.children;
    return react_1.default.createElement("main", {
      className: "main-page-wrapper"
    }, children);
  };

  BB8MainPage.Padded = function (_a) {
    var children = _a.children;
    return react_1.default.createElement("section", {
      className: "main-page padded"
    }, children);
  };

  BB8MainPage.Full = function (_a) {
    var children = _a.children;
    return react_1.default.createElement("section", {
      className: "main-page"
    }, children);
  };

  return BB8MainPage;
}(react_1.default.Component);

BB8MainPage.Padded.displayName = "BB8MainPage.Padded";
BB8MainPage.Full.displayName = "BB8MainPage.Full";
exports.default = BB8MainPage;